(() => {
  const colors = ['#c9a227', '#f2ead1', '#ffffff', '#8b0000'];
  let lastAdd = 0;

  const burst = () => {
    if (document.hidden) return;
    const canvas = document.createElement('canvas');
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const width = window.innerWidth;
    const height = window.innerHeight;
    canvas.width = width * dpr;
    canvas.height = height * dpr;
    canvas.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:2147483647;';
    document.body.appendChild(canvas);
    const ctx = canvas.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    const particles = Array.from({ length: 42 }, () => ({
      x: width / 2 + (Math.random() - 0.5) * 110,
      y: Math.max(90, height * 0.28),
      vx: (Math.random() - 0.5) * 8,
      vy: -Math.random() * 7 - 3,
      size: Math.random() * 5 + 3,
      rotation: Math.random() * Math.PI,
      spin: (Math.random() - 0.5) * 0.25,
      color: colors[Math.floor(Math.random() * colors.length)],
      alpha: 1
    }));
    const started = performance.now();
    const animate = (now) => {
      const elapsed = now - started;
      ctx.clearRect(0, 0, width, height);
      particles.forEach((p) => {
        p.x += p.vx;
        p.y += p.vy;
        p.vy += 0.18;
        p.rotation += p.spin;
        p.alpha = Math.max(0, 1 - elapsed / 1200);
        ctx.save();
        ctx.globalAlpha = p.alpha;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.65);
        ctx.restore();
      });
      if (elapsed < 1200) requestAnimationFrame(animate);
      else canvas.remove();
    };
    requestAnimationFrame(animate);
  };

  const fireOnce = () => {
    const now = Date.now();
    if (now - lastAdd < 450) return;
    lastAdd = now;
    burst();
  };
  const isCartAdd = (url) => /\/cart\/add(?:\.js)?(?:[/?#]|$)/.test(String(url || ''));

  if (window.fetch) {
    const nativeFetch = window.fetch;
    window.fetch = function(input) {
      const url = input && input.url ? input.url : input;
      return nativeFetch.apply(this, arguments).then((response) => {
        if (response.ok && isCartAdd(url)) fireOnce();
        return response;
      });
    };
  }

  const nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function() {
    const url = arguments[1];
    if (isCartAdd(url)) {
      this.addEventListener('load', () => {
        if (this.status >= 200 && this.status < 300) fireOnce();
      }, { once: true });
    }
    return nativeOpen.apply(this, arguments);
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form && isCartAdd(form.action)) window.setTimeout(fireOnce, 80);
  }, true);
})();
